import React, { useRef } from "react";
import { Link } from "react-scroll";
import breakPoints from "helpers/Styles";

const StickyLinks = ({ listIndex, item, handleActiveNav, activeNav }) => {
  const stickLinkRef = useRef();

  const setActiveMobile = () => {
    // stickLinkRef.current?.scrollIntoView({
    //   inline: 'center',
    // });
    handleActiveNav(listIndex);
  };
  const setActiveDesktop = () => {
    handleActiveNav(listIndex);
  };

  return (
    <>
      <div className="list_item_desktop">
        <li
          className={activeNav === listIndex ? 'active_link' : ''}
          key={listIndex}
        >
          <Link
            onSetActive={setActiveDesktop}
            to={item}
            spy
            smooth
            offset={-80}
            duration={1000}
            delay={0}
          >
            <div className={activeNav === listIndex ? '' : 'link_text'}>
              {item}
            </div>
          </Link>
        </li>
      </div>
      <div className="list_item_mobile">
        <li
          className={activeNav === listIndex ? 'active_link' : ''}
          key={listIndex}
          ref={stickLinkRef}
        >
          <Link
            onSetActive={setActiveMobile}
            to={item}
            spy
            smooth
            offset={listIndex > 0 ? -140 : -140}
            duration={1000}
            delay={0}
          >
            <div className={activeNav === listIndex ? '' : 'link_text'}>
              {item}
            </div>
          </Link>
        </li>
      </div>

      <style jsx>
        {`
          .active_link {
            color: #fd0300 !important;
          }

          li {
            color: #e4e4e4;
            font-family: 'Roboto-Normal';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            cursor: pointer;
            padding-bottom: 20px;
            text-transform: uppercase;
          }
          li:hover {
            color: #fd0300;
          }
          @media (min-width: ${breakPoints.medium}) {
            .list_item_mobile {
              display: none;
            }
          }
          @media (max-width: ${breakPoints.medium}) {
            .list_item_desktop {
              display: none;
            }
            .active_link {
              color: #fd0300 !important;
            }
            li {
              // margin-left: 10px;
              padding-right: 24px;
              padding-bottom: 0px;
            }
            .link_text {
              background: -webkit-radial-gradient(
                center,
                transparent 5%,
                #e4e4e4
              );
              -webkit-background-clip: text;
            }
            .link_text:hover {
              color: #fd0300;
            }
          }
        `}
      </style>
    </>
  );
};

export default StickyLinks;
